import { get, patch, post, AHPLUS_API_URL, del } from 'api/ky';
import { type Journey } from 'models/Journey';
import { type EditableJourney } from 'reducers/editableJourney';
import { type HttpResponse } from 'types/api';

export const JOURNEYS_URL = `${AHPLUS_API_URL}/api/v2/journeys`;

export interface JourneyUpdate {
  name: string;
}

export interface JourneyResponse {
  journey: Journey;
}

export const fetchJourneys = async () => {
  return await get(JOURNEYS_URL);
};

export const fetchJourney = async (id: number) => {
  return await get(`${JOURNEYS_URL}/${id}`);
};

export const updateJourney = async (id: number, payload: JourneyUpdate) =>
  await patch(`${JOURNEYS_URL}/${id}`, payload);

export type IAddJourney = (
  journey: EditableJourney,
  token?: string,
) => Promise<HttpResponse>;

export const addJourney: IAddJourney = async (
  journey: EditableJourney,
  token = '',
) => await post(`${JOURNEYS_URL}?token=${token}`, journey);

export const checkDeletable = async (id: number) => {
  return await get(`${JOURNEYS_URL}/${id}/check_deletable`);
};

export const deleteJourney = async (id: number) =>
  await del(`${JOURNEYS_URL}/${id}`);
